import { safeCheckDevSwitchIsOn } from '../hooks/useDevSwitchIsOn';
import posthog from 'posthog-js';
import { getFlagOverrideValue } from 'src/utils/featureFlags';

const doDlog = (key: string, message: any, ...optionalParams: any[]) => {
	console.debug(`🔧::${key}::\n${message}`, ...optionalParams);
};

const HARDCODED_ALLOWED_KEYS = [
	'market_order_toasts',
	'v2_auctions',
	'MarketOrderToastIdHandler',
];
const HARDCODED_ALLOWED_KEYS_LOOKUP = new Set(HARDCODED_ALLOWED_KEYS);
// Keywords that are allowed in production
const PROD_ALLOWED_KEYS = [''];
const PROD_ALLOWED_KEYS_LOOKUP = new Set(PROD_ALLOWED_KEYS);

// Dynamic set of allowed keys from PostHog
let posthogAllowedKeysLookup = new Set<string>();
let isDlogConsoleEnabled = false;

// Update allowed keys from PostHog feature flags
const updatePostHogAllowedKeys = () => {
	const flagValue = posthog.getFeatureFlagPayload('DLOG_ALLOWED_KEYS');
	if (flagValue && Array.isArray(flagValue)) {
		// Filter out any non-string values and create a new Set
		posthogAllowedKeysLookup = new Set(
			flagValue.filter((value): value is string => typeof value === 'string')
		);
	} else {
		posthogAllowedKeysLookup.clear();
	}
};

const updateDlogConsoleEnabled = () => {
	isDlogConsoleEnabled =
		!!posthog.isFeatureEnabled('DLOG_CONSOLE_ENABLED') ||
		!!getFlagOverrideValue('DLOG_CONSOLE_ENABLED');
};

// Listen for feature flag updates
posthog.onFeatureFlags(() => {
	updatePostHogAllowedKeys();
	updateDlogConsoleEnabled();
});

updatePostHogAllowedKeys();
updateDlogConsoleEnabled();

export function dlog(key: string, message: any, ...optionalParams: any[]) {
	if (!isDlogConsoleEnabled) return;
	/**
	 * Prod allowed keys
	 */
	if (PROD_ALLOWED_KEYS_LOOKUP.has(key)) {
		doDlog(key, message, ...optionalParams);
	}

	/**
	 * PostHog logging for whitelisted keys
	 */
	if (posthogAllowedKeysLookup.has(key)) {
		posthog.capture('dlog_event', {
			key,
			message: typeof message === 'object' ? JSON.stringify(message) : message,
			additional_params:
				optionalParams.length > 0 ? JSON.stringify(optionalParams) : undefined,
			url: window.location.href,
			timestamp: new Date().toISOString(),
			//@ts-ignore
			authority: window?.walletContext?.publicKey?.toString(),
		});
	}

	if (process.env.NEXT_PUBLIC_ENV === 'mainnet-beta') {
		if (!safeCheckDevSwitchIsOn()) return;
	}

	if (HARDCODED_ALLOWED_KEYS_LOOKUP.has(key)) {
		doDlog(key, message, ...optionalParams);
	}
}
